export default {
  "post.noun.everything": "tudo",
  "noun.all.plural": "tudo",
  "noun.obligationsReport": "Extracto de conta",
  "noun.obligationsReportPdf": "Extrato de conta em PDF",
  "adj.read.plural": "lido",
  "adj.unread.plural": "não lido",
  "noun.none": "nehuma",

  "action.archive": "arquivar",
  "action.restore": "restaurar",
  "action.delete": "apagar",
  "action.markRead": "marcar como lido",
  "action.markUnread": "marcar como não lido",
  "action.accept": "Aceitar",
  "action.add": "Adicionar",
  "action.addCheckpoint": "Adicionar ponto de controlo",
  "action.addCondition": "Adicionar condição",
  "action.addNewRule": "Adicionar nova regra",
  "action.addToCalendar": "Adicionar ao calendário",
  "action.allowReplies": "Permitir respostas",
  "action.allowRepliesAll": "Permitir respostas todas",
  "action.allowForward": "Permitir reenvio",
  "action.attach": "Anexar",
  "action.cancel": "Cancelar",
  "action.clearCache": "Limpar cache",
  "action.close": "Fechar",
  "action.createNewType": "Criar novo tipo",
  "action.enable": "Ativar",
  "action.deselect": "Anular a seleção",
  "action.Download": "Descarregar",
  "action.form.addField": "Adicionar campo",
  "action.form.RemoveField": "Remover campo",
  "action.Forward": "Reenviar",
  "action.forward": "reenviar",
  "action.HideRecipients": "Ocultar destinatários",
  "action.highlightPost": "Destacar mensagem",
  "action.logout": "Terminar sessão",
  "action.notify": "Notificar",
  "action.pay": "Pagar",
  "action.post.addAttachment": "Adicionar anexo",
  "action.redact": "Redigir",
  "action.repeatEvery": "Repetir todos",
  "action.repeatOn": "Repetir em",
  "action.reply": "Responder",
  "action.replyAll": "Responder a todos",
  "action.schedulePublishDate": "Programar data de publicação",
  "action.scheduleExpirationDate": "Programar data de expiração",
  "action.save": "Guardar",
  "action.select": "Selecionar",
  "action.send": "Enviar",
  "action.sendAnswers": "Enviar respostas",
  "action.sendAnswer": "Enviar resposta",
  "action.Share": "Partilhar",
  "action.slideGps": "Deslizar gps",
  "action.undo": "Anular",
  "action.tapHereToUploadFiles": "Toque aqui para carregar ficheiros",

  "search": "Procurar",
  "PhiThreadFilters.Contains": "Contém",
  "PhiThreadFilters.From": "De",
  "PhiThreadFilters.Subject": "Assunto",
  "PhiThreadFilters.DateAround": "Encontro por volta",
  "PhiThreadFilters.day": "dia",
  "PhiThreadFilters.days": "dias",
  "PhiThreadFilters.week": "semana",
  "PhiThreadFilters.weeks": "semanas",
  "PhiThreadFilters.month": "mês",
  "PhiThreadFilters.Folder": "Pasta",
  "PhiThreadFilters.Inbox": "caixa de entrada",
  "PhiThreadFilters.Archive": "Arquivo",
  "PhiThreadFilters.Trash": "Lixo",
  "PhiThreadFilters.Type": "Tipo",
  "PhiThreadFilters.AnyType": "Todos os tipos",
  "PhiThreadFilters.Status": "Status",
  "PhiThreadFilters.StatusAny": "Lido e não lido",
  "PhiThreadFilters.StatusRead": "Lido",
  "PhiThreadFilters.StatusUnread": "não lido",
  "StateThreadFeed.Search": "Procurar",
  "StateThreadFeed.Cancel": "Cancelar",
  "notice.thereIsNothingHere": "Não há nada aqui",
  "PhiThreadFilters.DateAround": "Período",
  "action.addToCalendar": "Adicionar ao calendário",
  "noun.post.Title": "Assunto",
  "action.post.addAttachment": "Adicionar anexo",
  "post.settings.recipientsInvisible": "Ocultar destinatários",
  "post.settings.recipientsVisible": "Colocar destinatários visível",
  "post.settings.repliesOn": "Ativar respostas",
  "post.settings.repliesOff": "Desativar respostas",
  "post.settings.repliesAllOn": "Ativar respostas para todos",
  "post.settings.repliesAllOff": "Desativar respostas para todos",
  "post.settings.forwardOn": "Ativação do avanço",
  "post.settings.forwardOff": "Encaminhar desativado",
  "post.settings.highlightOn": "Apresentado no painel de instrumentos",
  "post.settings.highlightOff": "Não apresentado no painel de instrumentos",
  "post.settings.notificationsOn": "Ativar notificações",
  "post.settings.notificationsOff": "Desativar notificações",
	"noun.files" : "Ficheiros",
  "action.tapHereToUploadFiles": "Clicar aqui para anexar ficheiros",
	"action.post.addAttachment": "Adicionar anexo",
	"noun.post.preview": "antevisão",
  "noun.post.modifyFiles": "modificar ficheiros",
	"noun.post.delete": "apagar",
  "noun.post.selectDocument": "selecionar documento",
  "register.form.addRelative": "Cadastrar família",
	"register.form.addStudent": "Cadastrar aluno",
	"register.form.birthday": "Data de nascimento",
	"register.form.cancel": "Cancelar",
	"register.form.children": "Crianças",
	"register.form.children2": "Crianças",
	"register.form.course": "Curso",
	"register.form.course.pick": "-- Selecione o curso-- ",
	"register.form.email": "Endereço email",
	"register.form.error.birthday.empty": "Você deve selecionar uma data",
	"register.form.error.children.empty": "Você deve selecionar pelo menos um filho",
	"register.form.error.course.empty": "Você deve selecionar um curso",
	"register.form.error.email.empty": "Você deve escrever um e-mail",
	"register.form.error.email.invalid": "e-mail inválido",
	"register.form.error.email.taken": "Este e-mail já está sendo usado",
	"register.form.error.document.empty": "Você deve escrever um documento",
	"register.form.error.firstName.empty": "Você deve escrever um nome",
	"register.form.error.lastName.empty": "Você deve escrever um sobrenome",
	"register.form.error.password.empty": "Você deve inserir uma senha",
	"register.form.error.password.mismatch": "Senha não corresponde",
	"register.form.document": "Documento",
	"register.form.firstName": "Nome",
	"register.form.gender.female": "Feminino",
	"register.form.gender.male": "Masculino",
	"register.form.gender": "Genero",
	"register.form.lastName": "Apelido",
	"register.form.lastName2": "Segundo apelido",
	"register.form.loading": "Registrando",
	"register.form.password": "Palavra-passe",
	"register.form.submit": "Registo",
	"register.form.success.email": "Enviamos um e-mail <strong>{{email}}</strong> para com instruções para continuar o processo",
	"register.form.success.title": "Verifique seu e-mail!",
	"register.form.verifyPassword": "Confirmar palavra-passe",
  "published": "publicado",
  "notice.toMe": "para mim",
  "transport.whatsapp": "WhatsApp",
}